import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import DefaultAvatar from '../otherImages/default.png';

const BookingsOverviewOne = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Booking Services - Dummy mapping
  const serviceMap = {
    '1': { name: 'Cleaning Basic', color: 'primary', icon: 'mdi:broom' },
    '2': { name: 'Premium Cleaning', color: 'success', icon: 'mdi:sparkles' },
    '3': { name: 'Deep Cleaning', color: 'info', icon: 'mdi:water-percent' },
    '4': { name: 'Carpet Cleaning', color: 'warning', icon: 'mdi:vacuum' },
    '5': { name: 'Window Cleaning', color: 'danger', icon: 'mdi:window-closed' },
  };

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        setLoading(true);
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJhZG1pbkBjbGVhcnNoaW5lLmNvbSIsInJvbGUiOiJBRE1JTiIsImlhdCI6MTc3NzAzODEwOSwiZXhwIjoxNzc3MTI0NTA5fQ.92GeouFXPPwkcIbJ5S07Se67PA0emMXjq657RqwKzwk';

        const response = await fetch(
          'https://clearshine.koderspedia.online/get-bookings',
          {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error(`API Error: ${response.status}`);
        }

        const result = await response.json();
        if (result.success && result.data) {
          // Limit to 5 recent bookings
          setBookings(result.data.slice(0, 5));
        }
        setError(null);
      } catch (err) {
        console.error('Error fetching bookings:', err);
        setError(err.message);
        setBookings([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();
  }, []);

  const getServiceInfo = (serviceId) => {
    return serviceMap[serviceId] || {
      name: `Service ${serviceId}`,
      color: 'secondary',
      icon: 'mdi:tools',
    };
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="col-xl-12 col-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div>
            <h5 className="card-title mb-0">📋 Recent Bookings</h5>
            <small className="text-muted">Latest service bookings from customers</small>
          </div>
          <a href="/manage-bookings" className="btn btn-sm btn-primary">
            <Icon icon="mdi:eye" width="16" /> View All
          </a>
        </div>

        <div className="card-body">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className="alert alert-danger">
              <Icon icon="mdi:alert-circle" /> Error loading bookings: {error}
            </div>
          ) : bookings.length === 0 ? (
            <div className="alert alert-info">
              <Icon icon="mdi:information" /> No bookings found
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Customer</th>
                    <th>Service</th>
                    <th>Details</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {bookings.map((booking) => {
                    const service = getServiceInfo(booking.service);
                    return (
                      <tr key={booking.id}>
                        {/* Customer Name */}
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <img
                              src={DefaultAvatar}
                              alt={booking.name}
                              className="rounded-circle"
                              width="32"
                              height="32"
                            />
                            <div>
                              <p className="mb-0 fw-semibold">{booking.name}</p>
                              <small className="text-muted">{booking.email}</small>
                            </div>
                          </div>
                        </td>

                        {/* Service */}
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <Icon
                              icon={service.icon}
                              width="20"
                              className={`text-${service.color}`}
                            />
                            <span className="badge bg-light text-dark">
                              {service.name}
                            </span>
                          </div>
                        </td>

                        {/* Details (Date, Time, Unit) */}
                        <td>
                          <small className="d-block">
                            <strong>Date:</strong> {booking.date}
                          </small>
                          <small className="d-block">
                            <strong>Time:</strong> {booking.time}
                          </small>
                          <small className="d-block">
                            <strong>Unit:</strong> {booking.unit}
                          </small>
                        </td>

                        {/* Total Price */}
                        <td>
                          <span className="fw-bold text-success">
                            ${booking.totalPrice}
                          </span>
                        </td>

                        {/* Booking Date */}
                        <td>
                          <small>{formatDate(booking.createdAt)}</small>
                        </td>

                        {/* Status */}
                        <td>
                          <span className="badge bg-success">Active</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingsOverviewOne;
